<template>
    <div>
        <textarea v-model="result" class="textarea textarea-code" rows="16"></textarea>
    </div>
</template>

<script>
export default {
    name: 'string-text',
    props: {
        data: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            result: this.data
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/string-text.vue